let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lqiDs")).then(() => parcelRequire('9DvXk'));